export const formatINR = (value) => {
    if (value === undefined || value === null || isNaN(value)) return '₹0.00';

    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2, // Forces 2 decimal places (.00)
    }).format(value);
};

// export const formatINRCompact = (value) => {
//   return new Intl.NumberFormat('en-IN', {
//     style: 'currency',
//     currency: 'INR',
//     maximumFractionDigits: value % 1 === 0 ? 0 : 2,
//   }).format(value);
// };
// // Example: 150000 becomes ₹1,00,000 (No .00)
// // Example: 150000.50 stays ₹1,00,000.50
